import { Component, OnInit,Output, EventEmitter,Input} from '@angular/core';
import * as Globals from '../../globals';

@Component({
  selector: 'app-item-per-page-filter',
  templateUrl: './item-per-page-filter.component.html',
  styleUrls: ['./item-per-page-filter.component.scss']
})
export class ItemPerPageFilterComponent implements OnInit {

  itemPerPageNumList:any = [];
  itemPerPage:number;
  @Output() countSelectionChanged: EventEmitter<number> =  new EventEmitter<number>();
  @Input() item:number;

  constructor() {
    this.itemPerPageNumList = Globals.itemPerPageNumList;
   }

  ngOnInit() {
    console.log(this.item)
  }
  onSelectionChange() {
    this.countSelectionChanged.emit(this.item);
  }

}
